import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../assets/images/block-img1.svg'


const _hoisted_1 = { class: "bg-[#ffffff]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-full",
  alt: "blockImg"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "sm:text-[57px] text-[1.5rem] font-[700] pt-9 sm:pt-0" }, " Who we are ", -1)
const _hoisted_5 = { class: "my-6 text-[#617686]" }
const _hoisted_6 = {
  key: 0,
  class: "rounded-full text-white px-10 bg-[#690722] w-[174px] h-[57px] py-2 cursor-pointer font-bold hover:border-white hover:text-white"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'flex flex-row mx-auto max-w-7xl px-2 sm:px-6 justify-between items-center lg:px-8',
        'pt-[8rem] flex-wrap pb-[6rem] text-center sm:text-left',
        _ctx.mainPage ? 'pt-[11.5rem]' : '',
      ])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.mainPage ? 'w-full sm:w-[40%]' : 'w-full sm:w-[30%]')
      }, _hoisted_3, 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.mainPage ? 'w-full sm:w-[52%]' : 'w-full sm:w-[62%]')
      }, [
        _hoisted_4,
        _createElementVNode("article", _hoisted_5, _toDisplayString(_ctx.content), 1),
        (!_ctx.mainPage)
          ? (_openBlock(), _createElementBlock("button", _hoisted_6, " Know More "))
          : _createCommentVNode("", true)
      ], 2)
    ], 2)
  ]))
}